import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
 *,
  *::after,
  *::before {
    margin: 0;
    box-sizing: border-box;
  }

body{
font-family: 'Poppins', sans-serif;
}

.container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    width: 85%;
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 100%;
      padding: 15px;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90%;
    }
  }

img{
max-width: 100%;
}
`;

export default GlobalStyles;
